import React, { useState, useRef } from 'react';
import cn from 'classnames';
import style from './video.mod.scss';
import useMediaQuery from '@mui/material/useMediaQuery';
import { GatsbyImage } from 'gatsby-plugin-image';
import Container from '../layout/container/container';

const Video = ({ video, videoMobile, image }) => {
  const classes = cn(style.video);
  const player = useRef(null);
  const isMobile = useMediaQuery('(max-width:480px)');
  const [placeholder, setPlaceholder] = useState(true);
  const closePlaceholder = () => {
    setPlaceholder(false);
    player.current.play();
  };

  return (
    <Container size="lg" gutters>
      <div className={classes}>
        <video ref={player} playsInline controls>
          {isMobile && <source src={videoMobile.url} type="video/mp4" />}
          {!isMobile && <source src={video.url} type="video/mp4" />}
        </video>
        {placeholder && (
          <div className={style.video__image}>
            <GatsbyImage image={image.gatsbyImageData} alt={''} />
            <div className={style.video__play} onClick={closePlaceholder}>
              <Play />
            </div>
          </div>
        )}
      </div>
    </Container>
  );
};

export default Video;

const Play = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 125 125">
    <circle cx="62.5" cy="62.5" r="62.5" fill="#fff" fillOpacity="0.4"></circle>
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="5"
      d="M45.734 42.478c0-2.774 0-4.16.579-4.925a2.857 2.857 0 012.107-1.128c.957-.057 2.111.712 4.42 2.25L82.873 58.7c1.907 1.27 2.86 1.907 3.192 2.708.29.7.29 1.488 0 2.188-.332.801-1.285 1.437-3.192 2.708L52.839 86.326c-2.308 1.539-3.462 2.308-4.419 2.251a2.857 2.857 0 01-2.107-1.128c-.579-.764-.579-2.151-.579-4.925V42.478z"
    ></path>
  </svg>
);
